import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";

Vue.use(Vuex);

const vuexLocal = new VuexPersist({
  key: process.env.VUE_APP_PROJECT_KEY,
  storage: window.localStorage,
  modules: ["accessToken", "refreshToken", "user", "rememberAccess"],
});

export default new Vuex.Store({
  state: {
    accessToken: "",
    refreshToken: "",
    user: null,
    rememberAccess: "",
    currentRaffle: null,
    games: [
      /*       { value: "word-guess", eligible: true },
      { value: "chico-challenge", eligible: true, new: true },
      { value: "hangman-game", eligible: true },
      { value: "lucky-mines", eligible: true }, */
    ],
    bonusState: {
      eligible: false,
      earned: true,
    },
    settings: {},
    language: {
      flag: "BR",
      value: "PT",
      label: "Português",
    },
  },

  getters: {
    authenticated: ({ accessToken, refreshToken, user }) =>
      !!accessToken && !!refreshToken && !!user,
    accessToken: ({ accessToken }) => accessToken,
    refreshToken: ({ refreshToken }) => refreshToken,
    user: ({ user }) => user,
    rememberAccess: ({ rememberAccess }) => rememberAccess,
    currentRaffle: ({ currentRaffle }) => currentRaffle,
    games: ({ games }) => games,
    bonusState: ({ bonusState }) => bonusState,
    settings: ({ settings }) => settings,
    features: ({ settings }) =>
      (settings.modules || []).reduce(
        (a, e) => ({ ...a, [e.module]: e.active }),
        {}
      ),
    language: ({ language }) => language,
  },

  mutations: {
    SET_ACCESS_TOKEN(state, payload) {
      state.accessToken = payload;
    },

    SET_REFRESH_TOKEN(state, payload) {
      state.refreshToken = payload;
    },

    SET_USER(state, payload) {
      state.user = payload;
    },

    SET_REMEMBER_ACCESS(state, payload) {
      state.rememberAccess = payload;
    },

    SET_CURRENT_RAFFLE(state, payload) {
      state.currentRaffle = payload;
    },

    RESET_GAMES(state) {
      state.games = state.games.map((el) => ({ ...el, eligible: true }));
    },

    SET_GAMES(state, payload) {
      state.games = payload;
    },

    SET_GAME_ELIGIBILITY(state, payload) {
      const index = state.games.findIndex((el) => el.value === payload.game);

      if (index >= 0) {
        state.games[index].eligible = payload.value;
      }
    },

    SET_BONUS_ELIGIBLE(state, payload) {
      state.bonusState.eligible = payload;
    },

    SET_BONUS_EARNED(state, payload) {
      state.bonusState.earned = payload;
    },

    SET_SETTINGS(state, payload) {
      state.settings = payload;
    },
  },

  actions: {
    setAccessToken({ commit }, payload) {
      commit("SET_ACCESS_TOKEN", payload);
    },

    setRefreshToken({ commit }, payload) {
      commit("SET_REFRESH_TOKEN", payload);
    },

    setUser({ commit }, payload) {
      commit("SET_USER", payload);
    },

    setRememberAccess({ commit }, payload) {
      commit("SET_REMEMBER_ACCESS", payload);
    },

    setSignIn({ dispatch }, payload) {
      dispatch("setAccessToken", payload.accessToken);
      dispatch("setRefreshToken", payload.refreshToken);
      dispatch("setUser", payload.user);
    },

    setSignOut({ dispatch }) {
      dispatch("setAccessToken", "");
      dispatch("setRefreshToken", "");
      dispatch("setUser", null);
      dispatch("setBonusEligible", false);
      dispatch("setBonusEarned", true);
      dispatch("resetGames");
    },

    setCurrentRaffle({ commit }, payload) {
      commit("SET_CURRENT_RAFFLE", payload);
    },

    setGameEligibility({ commit }, payload) {
      commit("SET_GAME_ELIGIBILITY", payload);
    },

    setBonusEligible({ commit }, payload) {
      commit("SET_BONUS_ELIGIBLE", payload);
    },

    setBonusEarned({ commit }, payload) {
      commit("SET_BONUS_EARNED", payload);
    },

    resetGames({ commit }) {
      commit("RESET_GAMES");
    },

    setGames({ commit }, payload) {
      commit("SET_GAMES", payload);
    },

    setSettings({ commit }, payload) {
      commit("SET_SETTINGS", payload);
    },
  },

  modules: {},

  plugins: [vuexLocal.plugin],
});
